import './login.scss';
import _ from 'lodash'
import { AuthService, User, userSelectors } from '@skinsoft/auth';
import { fetch } from '@skinsoft/network';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { FORM_ERROR } from 'final-form';
import { get } from 'lodash';
import { race } from 'rxjs';
import { first, map, mapTo, switchMap } from 'rxjs/operators';
import { Component } from 'vue-property-decorator';

import { fetchLocale } from '@skinsoft/i18n/src/fetch-locale';
import { LoginForm } from '../login-form';
import { InstitutionDataStore } from '@skinsoft/entity';

@Component({
    components: {
        sLoginForm: LoginForm,
    },
    props: ['homeRoute'],
    template: require('./login.html'),
})
export class Login extends ReactiveVue {
    public $authService: AuthService;

    private homeRoute: string;
    private $institutionDataStore: InstitutionDataStore;

    public created() {
        this.subscribeTo(this.$authService.user$, this.onUser);
    }

    public async onSubmit(values: Record<'username' | 'password', string>) {
        await this.$authService.logIn(values.username, values.password);

        const success$ = this.$authService.waitFor$('authenticated').pipe(mapTo(null));
        const error$ = this.$authService.waitFor$('unauthenticated').pipe(
            map(value => {
                const [, event] = value;
                const error = get(event, 'query.error', null);

                if (!error) {
                    return null;
                }

                return {
                    [FORM_ERROR]: fetch.isNetworkError(error)
                        ? 'auth.login.error.network'
                        : 'auth.login.error.credentials',
                };
            }),
        );

        return await race(success$, error$)
            .pipe(first())
            .toPromise();
    }

    private async onUser(user: User | null) {
        if (user) {
            const userLocale = userSelectors.defaultInterfaceLanguage(user);
            await fetchLocale(userLocale);
            this.$root.$i18n.locale = userLocale;
            if(localStorage.getItem('workspace') == null){
                localStorage.setItem('workspace', userSelectors.defaultWorkspace(user).id)
            }
            this.$institutionDataStore.fetchAllByWorkspace(localStorage.getItem('workspace') as string).subscribe(
                institution => {
                    localStorage.setItem('institution', _.get(institution, '_embedded.institution[0].id'));
                    return fetch.api(`/users/token?institutionId=${_.get(institution, '_embedded.institution[0].id')}&workspaceId=${localStorage.getItem('workspace')}`,
                    {
                        method: 'GET',
                    })
                }
            )
            localStorage.setItem('preferredLocale', userLocale);
            this.$router.push({ name: this.homeRoute });
            return;
        }
    }
}
